import { graphql } from 'gql';

export const bimUploadPriceFilesForWorkOrderChangeGql = graphql(`
    mutation bimUploadPriceFilesForWorkOrderChange(
        $workOrderChangeId: Long!
        $workOrderObjectId: Long
        $workOrderChangeObjectId: Long
        $chapter: BimChapterEnum!
        $rationale: String!
        $filesContent: [FileInput!]!
    ) {
        bimUploadPriceFilesForWorkOrderChange(
            workOrderChangeId: $workOrderChangeId
            workOrderObjectId: $workOrderObjectId
            workOrderChangeObjectId: $workOrderChangeObjectId
            chapter: $chapter
            rationale: $rationale
            filesContent: $filesContent
        ) {
            data {
                itemIds
                workOrderChangeId
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);
